import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ResumeReuploadPage from "@/pages/careers/ResumeReuploadPage";

export const Route = createFileRoute("/careers/resume-reupload/$token")({
  head: () => pageHead("Re-upload your resume | AKIVA Careers", "Securely upload an updated resume for your AKIVA job application using the link from your email.", "/careers/resume-reupload/$token", true),
  component: ResumeReuploadPage,
});
